var _mask, _path, _path2, _mask2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 24,
    viewBox: "0 0 208 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_101_147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.668945 10.8911H82.7639V12.8911H0.668945V10.8911Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.668945 12.8911H82.7639V8.89111H0.668945V12.8911Z",
    fill: "#fff",
    mask: "url(#path-1-inside-1_101_147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8655 16.0786C91.4163 16.0786 91.1467 15.5396 91.5061 15.1802L94.5159 12.1704C94.7405 11.9458 95.0549 11.9458 95.2795 12.1704L98.2893 15.1802C98.6487 15.5396 98.3792 16.0786 97.9299 16.0786H96.3127C97.2561 18.5493 100.176 19.9868 102.826 20.3462V11.7661H100.49C100.176 11.7661 99.9514 11.5415 99.9514 11.2271V9.43018C99.9514 9.16064 100.176 8.89111 100.49 8.89111H102.826V8.6665C101.119 8.08252 99.9514 6.46533 99.9514 4.57861C99.9514 2.19775 101.883 0.266113 104.309 0.311035C106.645 0.311035 108.576 2.24268 108.531 4.62354C108.531 6.46533 107.364 8.08252 105.656 8.6665V8.89111H107.992C108.307 8.89111 108.531 9.16064 108.531 9.43018V11.2271C108.531 11.5415 108.307 11.7661 107.992 11.7661H105.656V20.3462C108.352 19.9868 111.227 18.5493 112.17 16.0786H110.553C110.104 16.0786 109.834 15.5396 110.194 15.1802L113.203 12.1704C113.428 11.9458 113.742 11.9458 113.967 12.1704L116.977 15.1802C117.336 15.5396 117.067 16.0786 116.617 16.0786H115.135C114.147 20.7056 109.026 23.2661 104.264 23.2661C99.4573 23.2661 94.3362 20.7056 93.3479 16.0786H91.8655ZM104.264 3.14111C103.455 3.14111 102.826 3.81494 102.826 4.57861C102.826 5.38721 103.455 6.01611 104.264 6.01611C105.028 6.01611 105.701 5.38721 105.701 4.57861C105.701 3.81494 105.028 3.14111 104.264 3.14111Z",
    fill: "#2DD6D4"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_101_147",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.764 10.8911H207.859V12.8911H125.764V10.8911Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.764 12.8911H207.859V8.89111H125.764V12.8911Z",
    fill: "#fff",
    mask: "url(#path-4-inside-2_101_147)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor2);
export default __webpack_public_path__ + "static/media/anchor2.e75e71eb696018ddd6c8f08aef0e6b86.svg";
export { ForwardRef as ReactComponent };